module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/ZoomPlus-9a20d200ecf115cae66bdb683be9c2e8.svg";